import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=40b5bdb3&scoped=true&"
import script from "./TaskOverview.vue?vue&type=script&lang=js&"
export * from "./TaskOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5bdb3",
  null
  
)

export default component.exports